/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type LogType } from './export.enum';

/**
 * 精简诊断信息每张二维码展示长度
 */
export const STREAMLINE_DIAGNOSTIC_QRCODE_MAX_LENGTH = 1536;

/**
 * 起始页页码
 */
export const FIRST_PAGE_INDEX = 1;

/**
 * 加密时，添加的是否加密参数值
 */
export const EXPORT_LOG_ENCRYPTED_VALUE = 1;

/**
 * 精简诊断信息导出前查询tag
 */
export const STREAMLINE_DIAGNOSTIC_QUERY_BEFORE_EXPORT_TAG = 'get_path';

/**
 * 日志item
 */
export interface ExportItems {
    /**
     * 日志类型
     */
    type: LogType;
    /**
     * 日志名称
     */
    label: string;
    /**
     * 是否加载中
     */
    isLoading: boolean;
    /**
     * 日志大小和下载时间
     */
    tips: string;
    /**
     * 图标
     */
    icon: string;
    /**
     * 所需权限
     */
    permissions: string[];
}

/**
 * 精简关键信息二维码每张图片播放时间间隔(毫秒)
 */
export enum PlayTimeInterval {
    THREE_HUNDRED_MIllISECONDS = 300,
    FIVE_HUNDRED_MIllISECONDS = 500,
    ONE_SECONDS = 1000,
    ONE_POINT_FIVE_SECONDS = 1500,
    TWO_SECONDS = 2000,
    TWO_POINT_FIVE_SECONDS = 2500,
    THREE_SECONDS = 3000
}

/**
 * 精简关键信息二维码放大图键盘监听keycode
 */
export enum EventKeyDownKeyCode {
    ARROW_LEFT = 37,
    ARROW_RIGHT = 39,
    SPACE = 32,
}

/**
 * 精简关键信息二维码每张图片播放时间间隔(秒)
 */
export enum PlayTimeIntervalLabel {
    THREE_HUNDRED_MIllISECONDS = '0.3',
    FIVE_HUNDRED_MIllISECONDS = '0.5',
    ONE_SECONDS = '1',
    ONE_POINT_FIVE_SECONDS = '1.5',
    TWO_SECONDS = '2',
    TWO_POINT_FIVE_SECONDS = '2.5',
    THREE_SECONDS = '3',
}
